import { render, staticRenderFns } from "./InformherAttachments.vue?vue&type=template&id=d9540b46&scoped=true&"
import script from "./InformherAttachments.vue?vue&type=script&lang=js&"
export * from "./InformherAttachments.vue?vue&type=script&lang=js&"
import style0 from "./InformherAttachments.vue?vue&type=style&index=0&id=d9540b46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9540b46",
  null
  
)

export default component.exports